export const EnvirontmentType ={
    DEV:"DEV", 
    PRE:"PRE"
} 